import { aboutInfo } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
              {aboutInfo.title}
            </h2>
          </div>

          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
            <div className="flex-shrink-0 w-full lg:w-[380px]">
              <div className="aspect-[4/3] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20digital%20media%20newsroom%20with%20large%20screens%20displaying%20video%20content%2C%20warm%20lighting%2C%20professional%20editorial%20workspace%2C%20content%20curation%20team%20at%20work%2C%20sleek%20modern%20interior%2C%20red%20and%20amber%20accent%20lights&width=760&height=570&seq=about-main&orientation=landscape"
                  alt="91黑料平台介绍 - 专业黑料视频编辑团队"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
            </div>

            <div className="flex-1">
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {aboutInfo.content}
              </p>
              <div className="mt-6 grid grid-cols-2 gap-3">
                {aboutInfo.highlights.map((item, idx) => (
                  <div
                    key={idx}
                    className="flex items-center gap-2 p-3 bg-background-100 rounded-lg"
                  >
                    <div className="w-8 h-8 bg-primary-100 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-primary-500" />
                    </div>
                    <span className="text-sm font-medium text-foreground-800">{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}